var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.focusedClient)?[_c('ChildStonks')]:[_c('div',{ref:"entryPanel",staticClass:"scrollable is-flex is-flex-direction-column"},[_c('article',{staticClass:"p-3 article",staticStyle:{"text-align":"center"}},[_vm._v(" Kein Klient ausgewählt! ")])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }